export default "__VITE_ASSET__DPMoT9VK__"